import React, { Component } from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';
import { Link } from 'react-router-dom';
import { Price } from '../Price';

const BonusWrapper = styled('div')`
  display: block;
  font-size: 12px;
  line-height: 16px;
`;

const BonusDescription = styled('p')`
  display: block;
  text-align: left;
  font-weight: 600;
`;

const MembershipLink = styled(Link)`
  display: block;
  color: ${({ theme }) => theme.colors.product.membershipLink};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`;

const StyledPrice = styled(Price)`
  margin-left: 3px;
  ${Price.Normal} {
    font-weight: bold;
    font-size: 12px;
  }
`;

const PriceDiscountWrapper = styled('div')`
  display: flex;
  flex-direction: row;
`;

const WebBonus = ({ price, webBonus, className }) => {
  const { discount = 5, heading, text } = webBonus;

  const calculatePrice = price => ({
    ...price,
    incVat: Math.ceil(((100 - discount) / 100) * price.incVat)
  });

  return (
    <BonusWrapper className={className}>
      <BonusDescription>{heading || 'Har du webbonus?'}</BonusDescription>
      <PriceDiscountWrapper>
        <p>{text || `Ytterligare ${discount}% rabatt:`}</p>
        <StyledPrice price={calculatePrice(price)} />
      </PriceDiscountWrapper>

      <MembershipLink to="/evalds-kund-webbonus">
        {t('Become member')} >
      </MembershipLink>
    </BonusWrapper>
  );
};

export default WebBonus;
